/**
 * @file Delete assignment
 * @author Heino Lenting
 */
import * as tslib_1 from "tslib";
import { DeleteBase } from './delete';
var AssignmentDelete = /** @class */ (function (_super) {
    tslib_1.__extends(AssignmentDelete, _super);
    /**
     * Creates an instance of AssignmentDelete.
     */
    function AssignmentDelete(domainService, overlayService, dropTargetsService, dialogService, translateService, userService, resourceService) {
        return _super.call(this, 'assignment-delete', 'APP.EXECUTORS.ASSIGNMENT_DELETE_NAME', ['Assignment'], 'Assignment', domainService, overlayService, dropTargetsService, dialogService, translateService, userService, resourceService) || this;
    }
    return AssignmentDelete;
}(DeleteBase));
export { AssignmentDelete };
